<section class="iguau-banner-home" [style.background-image]="'url(' + imagenUrl + ')'" aria-labelledby="iguau-banner-home-title">
  <div class="iguau-banner-home__inner">
    <div class="iguau-banner-home__intro">
      <h1 id="iguau-banner-home-title" class="iguau-banner-home__title">
        <span>{{ titulo1 }}</span>
        <span>{{ titulo2 }}</span>
        <span class="iguau-banner-home__heart" aria-hidden="true">♡</span>
      </h1>
      <p class="iguau-banner-home__description">{{ descripcion }}</p>
    </div>

    <nav class="iguau-banner-home__nav" aria-label="Descubre iGuau">
      <a class="iguau-banner-home__item" *ngFor="let acceso of accesos; let i = index; trackBy: trackByUrl"
         [href]="urlAcceso(acceso, i)" [attr.aria-label]="ariaAcceso(acceso, i)">
        <span class="iguau-banner-home__icon" aria-hidden="true">
          <i class="fa-solid" [class]="'fa-solid ' + iconoAcceso(acceso, i)"></i>
        </span>
        <span class="iguau-banner-home__label">
          <span>{{ tituloAcceso(acceso, i) }}</span>
          <span>{{ subtituloAcceso(acceso, i) }}</span>
        </span>
      </a>
    </nav>
  </div>
</section>
